function view_cart() {
    var $ = jQuery.noConflict();
    $('html, body').animate({scrollTop: 0}, 'fast', 'swing', function() { });
    counter = 0;

    $('#cart-view').removeClass('hide');
    clearCheckoutError();
    $('.wf-ordering-container').addClass('hide');
    // console.log('view cart'); 
}
function not_view_cart() {
    var $ = jQuery.noConflict();

    $('#cart-view').addClass('hide');
    $('.wf-ordering-container').removeClass('hide');
    // console.log('not view cart');

}